export type PeelTagFace = "front" | "back";

/** Only a completed copy may reveal the confirmation face. */
export function peelFaceAfterCopy(copied: boolean, reduced: boolean): PeelTagFace {
	return copied && !reduced ? "back" : "front";
}
